module.exports = __webpack_public_path__ + "static/the-professor-and-the-madman-698dbbdcd2fc53d3d5f2a707636217b4.jpg";